import styled from 'astroturf/react';

const CapHeaderTable = styled('table')`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
`;

const CapHeader = styled('div')`
  padding: 15px;
  border: 0.5px solid var(--ph-gray-250);
  margin-bottom: 20px;
`;

const CapHeaderTitle = styled('h2')`
  font-size: var(--ph-text-md);
  font-family: var(--ph-font-family-lato-heavy);
  color: var(--dark-blue);
`;

const CapHeaderColumn = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: 11px;
  line-height: 1.5;
  border-left: 0.5px solid var(--dark-blue);
  padding-left: 10px;
  padding-right: 10px;

  &.head {
    border-left: none;
    padding-left: 0;
  }

  span:first-child  {
    font-family: var(--ph-font-family-lato-heavy);
    color: var(--dark-blue);
  }
`;

const CapHeaderFieldLabel = styled('label')`
  font-family: var(--ph-font-family-lato-heavy);
  color: var(--dark-blue);

  &:before {
    content: ' ';
    display: inline-block;
    height: 1em;
    width: 1em;
    clip-path: circle(2px at center);
    background-color: var(--cyan-green);
  }
`;

export default {
  CapHeaderTable,
  CapHeader,
  CapHeaderTitle,
  CapHeaderColumn,
  CapHeaderFieldLabel
};
